<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <h2 class="h h--2 h--dark">Nagrody</h2>
                <p class="paragraph">Poznaj i zamawiaj nagrody, jakie przygotowaliśmy w Programie Geberit Pro.</p>
                <user-points-info-widget/>
                <p class="paragraph"><router-link :to="{name: 'MyPrizes'}" class="">Zamówione nagrody &raquo;</router-link></p>
            </div>
            <div class="col-lg-8">
                <div class="row prize">
                    <router-link :to="{name: 'Prizes'}" class="prize__close"></router-link>
                    <div class="col-md-5">
                        <img v-if="prize.photo_id" v-auth-image="'/photos/'+ prize.photo_id + '?thumbnail=300'" alt="" class="prize__img"  @click="showImg(prize.photo_id)" />
                        <div class="row" style="margin-top: 30px;">
                            <div class="col-lg-6" v-for="(photo, pindx) in prize.photos" :key="photo.id" v-if="pindx > 0">
                                <img v-auth-image="'/photos/'+ photo.id + '?thumbnail=150'" alt="" class="prize__img" @click="showImg(photo.id)"  />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <h3 class="prize__name">{{ prize.name }}</h3>
                        <p class="prize__desc">{{ prize.description }}</p>

                        <div v-if="prize.withdrawed_from_offer == 1 || prize.is_over_limit" class="button button--small button--dark prizes__item-button button--height-auto">
                            <span v-if="prize.withdrawed_from_offer == 1">
                                Wycofany z oferty
                            </span>
                            <span v-else>
                                Osiągnąłeś już limit nagród z 
                                <span v-if="prize.category.user_limit">
                                    grupy <b>{{ prize.category.name }}</b>
                                </span>
                                <span v-else="prize.group.user_limit">
                                    grupy <b>{{ prize.group.name }}</b>
                                </span>
                            </span>
                        </div>

                        <div v-else>

                            <div class="prize__modifiers">
                                <b-form-select v-model="modifiers[modifier[0].type.name]" :options="options(modifier)" class="prize__modifier" v-for="modifier in prize.modifiers" :key="modifier.id">
                                    <template slot="first">
                                        <option :value="null" disabled>Wybierz {{ modifier[0].type.name }}</option>
                                    </template>
                                </b-form-select>
                            </div>


                            <div v-if="prize.display_points_remaining">
                                <div v-if="(parseFloat(prize.value) > parseFloat(user.total_points))">
                                    <div class="prizes__item-points prizes__item-points--left" >
                                        Brakuje Ci jeszcze tylko 
                                        <b>{{ Math.ceil(parseFloat(prize.value) - parseFloat(user.total_points)) | point }} pkt</b>
                                    </div>
                                    <b-progress v-if="prize.value > (user.total_points)" :value="(user.total_points)*100" :max="prize.value*100" class="mb-3 progress-left" ></b-progress>
                                </div>
                                <div v-else>
                                    <div class="prizes__item-points prizes__item-points--complete">
                                        Masz wystarczającą ilość punktów na tę nagrodę!
                                    </div>
                                    <b-progress :value="100" :max="100" class="mb-3 progress-complete"></b-progress>
                                </div>
                            </div>

                            <div v-if="prize.order_many">
                                <div class="prizes__item-points prizes__item-points--left" >
                                    Ilość (maks. {{ max_order }})
                                </div>
                                <div class="row" >
                                    <div class="col-md-6">
                                        <div class="form__input-container">
                                            <input type="number" v-model="quantity" name="quantity" min="1" step="1" :max="max_order" class="form__input" placeholder="Ilość do zamówienia" required>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="prize__value">
                                            {{ prize.value*quantity | point }} pkt
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="prize__value" v-else>
                                {{ prize.value | point }} pkt
                            </div>

                            <div class="clearfix"></div>
                            <button class="button button--small button--filled-blue prize__order-button" @click="order" :disabled="submitted">Zamów &raquo;</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget prizes="true"></page-box-set-widget>
        <div class="overlay" v-if="selected_photo">
            <img src="../../../assets/img/close.png" alt="" class="overlay__close" @click="closeImg()" />
            <div class="overlay__container d-flex justify-content-center align-items-center">
                <img v-auth-image="'/photos/' + selected_photo" />
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { store } from '@/app/store'

    export default {
        name: 'PrizeComponent',
        data () {
            return {
                prize: [],
                max_order: 0,
                modifiers: [],
                selected: null,
                submitted: false,
                selected_photo: null,
                quantity: 1
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        mounted: function() {
            if( !this.user || this.user.id != 1 ) {
                this.$gtag.pageview({
                    page_path: '/nagrody/' + this.$route.params.id,
                })
            }
        },
        beforeRouteEnter(to, from, next) {
            /**
            * Get current user object.
            */
            Vue.axios({
                method: 'get',
                url: '/prizes/' + to.params.id
            })
            .then(response => {
                var mods = {}
                Object.keys(response.data.data.prize.modifiers).forEach(function(item, index) {
                    mods[item] = null
                })
                next(vm => {
                    vm.prize = response.data.data.prize
                    vm.max_order = response.data.data.max_order
                    vm.modifiers = mods
                    // vm.quantity = vm.max_order > 0 ? 1 : 0
                })
            })
            .catch(error => next(false))
        },
        methods: {
            options: function (values) {
                const options = values.map(o => {
                    return {
                        value: o.id,
                        text: o.name
                    };
                });

                return options;
            },
            order: function() {
                var _this = this
                var prize_id = this.$route.params.id
                _this.submitted = true

                for( var item in this.modifiers ) {
                    if( !this.modifiers[item] ) {
                        _this.submitted = false
                        return this.$toaster.error("Wybierz " + item + " nagrody")
                    }
                }

                Vue.axios({
                    method: 'post',
                    url: '/prizes/order',
                    data: {
                        prizes: [
                            {
                                id: prize_id,
                                modifiers: this.modifiers,
                                quantity: this.quantity
                            }
                        ]
                    }
                })
                .then(response => {
                    this.$toaster.success(response.data.message)
                    _this.submitted = false
                    if(this.prize.cert_only) {
                        var new_points = _this.user.total_points - _this.prize.value;
                        store.dispatch('changeUser', {key: 'total_points', value: new_points.toFixed(1)})
                    } else {
                        var new_money = _this.user.money - _this.prize.value;
                        store.dispatch('changeUser', {key: 'money', value: new_money.toFixed(2)})
                    }
                })
                .catch(error => {
                    let displayErrors = 0;
                    if(error.response.data.errors != undefined ) {
                        let errors = error.response.data.errors;
                        for (var key in errors) {
                            if (errors.hasOwnProperty(key)) {
                                for (var i = errors[key].length - 1; i >= 0; i--) {
                                    displayErrors++;
                                    this.$toaster.error(errors[key][i]);
                                }
                            }
                        }
                    }
                    if (!displayErrors) { 
                        this.$toaster.error(error.response.data.message)
                    }
                    _this.submitted = false
                })
            },
            showImg: function(image_id) {
                this.selected_photo = image_id
            },
            closeImg: function() {
                this.selected_photo = null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/PrizeComponent.vue